import type { ThemePalette } from "./types";

export const solarizedDark: ThemePalette = {
	id: "solarized-dark",
	name: "Solarized Dark",
	family: "solarized",
	appearance: "dark",

	background: "#002b36",
	foreground: "#839496",
	card: "#073642",
	cardForeground: "#839496",
	popover: "#073642",
	popoverForeground: "#839496",

	primary: "#268bd2",
	primaryForeground: "#fdf6e3",
	secondary: "#073642",
	secondaryForeground: "#839496",
	muted: "#073642",
	mutedForeground: "#586e75",
	accent: "#2aa198",
	accentForeground: "#fdf6e3",
	destructive: "#dc322f",
	destructiveForeground: "#fdf6e3",

	border: "#586e75",
	input: "#073642",
	ring: "#268bd2",

	success: "#859900",
	warning: "#b58900",
	error: "#dc322f",
	info: "#268bd2",

	chart1: "#268bd2",
	chart2: "#2aa198",
	chart3: "#859900",
	chart4: "#6c71c4",
	chart5: "#d33682",
};

export const solarizedLight: ThemePalette = {
	id: "solarized-light",
	name: "Solarized Light",
	family: "solarized",
	appearance: "light",

	background: "#fdf6e3",
	foreground: "#657b83",
	card: "#eee8d5",
	cardForeground: "#657b83",
	popover: "#eee8d5",
	popoverForeground: "#657b83",

	primary: "#268bd2",
	primaryForeground: "#fdf6e3",
	secondary: "#eee8d5",
	secondaryForeground: "#657b83",
	muted: "#eee8d5",
	mutedForeground: "#93a1a1",
	accent: "#2aa198",
	accentForeground: "#fdf6e3",
	destructive: "#dc322f",
	destructiveForeground: "#fdf6e3",

	border: "#93a1a1",
	input: "#eee8d5",
	ring: "#268bd2",

	success: "#859900",
	warning: "#b58900",
	error: "#dc322f",
	info: "#268bd2",

	chart1: "#268bd2",
	chart2: "#2aa198",
	chart3: "#859900",
	chart4: "#6c71c4",
	chart5: "#d33682",
};
